// /sign-up and /sign-up?returnTo=<path> (FR-004 to FR-009; routes.md).
import { SignUpScreen } from "@/auth/email/SignUpScreen";

export default function SignUp() {
  return <SignUpScreen />;
}
